module.exports = __webpack_public_path__ + "img/長型會客區.41cb33a0.jpg";